import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { GoogleLogo } from '../logos/GoogleLogo';
import { MicrosoftLogo } from '../logos/MicrosoftLogo';
import { OAuthButton } from '../OAuthButton';

const OAUTH_GOOGLE = 'oauth_google' as const;
const OAUTH_MICROSOFT = 'oauth_microsoft' as const;

export enum AuthMode {
  LOGIN = 'login',
  SIGNUP = 'signup',
}

interface OAuthButtonsGroupProps {
  mode: AuthMode;
  onGoogle: () => void;
  onMicrosoft: () => void;
  isAuthenticating?: boolean;
}

const stylesheet = {
  container: 'flex flex-col gap-3',
};

export function OAuthButtonsGroup({
  mode,
  onGoogle,
  onMicrosoft,
  isAuthenticating = false,
}: Readonly<OAuthButtonsGroupProps>): ReactNode {
  const { t } = useTranslation();

  const isLogin = mode === AuthMode.LOGIN;
  const googleLabel = isLogin
    ? t('login.continueWithGoogle')
    : t('signup.signUpWithGoogle');
  const microsoftLabel = isLogin
    ? t('login.continueWithMicrosoft')
    : t('signup.signUpWithMicrosoft');

  return (
    <div className={stylesheet.container}>
      <OAuthButton
        logo={<GoogleLogo />}
        label={googleLabel}
        onClick={onGoogle}
        isDisabled={isAuthenticating}
      />
      <OAuthButton
        logo={<MicrosoftLogo />}
        label={microsoftLabel}
        onClick={onMicrosoft}
        isDisabled={isAuthenticating}
      />
    </div>
  );
}

export { OAUTH_GOOGLE, OAUTH_MICROSOFT };
